import QRCode from 'qrcode';

/** A QR code as inline SVG (prints and copies without loading anything): dark modules on white. */
const QrCode = ({ text, size = 96 }: { text: string; size?: number }) => {
  const { modules } = QRCode.create(text, { errorCorrectionLevel: 'M' });
  const n = modules.size;
  let path = '';
  for (let y = 0; y < n; y++) {
    for (let x = 0; x < n; x++) {
      if (modules.get(y, x)) path += `M${x + 2} ${y + 2}h1v1h-1z`;
    }
  }
  return (
    <svg width={size} height={size} viewBox={`0 0 ${n + 4} ${n + 4}`} shapeRendering="crispEdges" style={{ display: 'block', margin: '0 auto' }} aria-hidden="true">
      <rect width={n + 4} height={n + 4} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
};

export default QrCode;
